import React from 'react';
import './sourcecode.css';
import Cards from './ReactJs/Cards/Cards';
import Header from './ReactJs/Header/Header';
import Footers from './ReactJs/Footer/Footers';
import Images from './ReactJs/Images/Images';
import Sidebar from './ReactJs/Sidebar/Sidebar';
import Logins from './ReactJs/Logins/Logins';

const SourceCode = () => {
    return (
        <div className="mainsourcecode">
            <div className="sourcecode">
                <input type="radio" name="slider" defaultChecked id="cards" />
                <input type="radio" name="slider" id="header" />
                <input type="radio" name="slider" id="footer" />
                <input type="radio" name="slider" id="sidebarcode" />
                <input type="radio" name="slider" id="image" />
                <input type="radio" name="slider" id="login" />
                <div className="optionofTabs">
                    <label htmlFor="cards" className="cards"><i className="fas fa-React"></i>Cards</label>
                    <label htmlFor="header" className="header"><i className="fas fa-blog"></i>Header</label>
                    <label htmlFor="footer" className="footer"><i className="fas fa-code"></i>Footer</label>
                    <label htmlFor="sidebarcode" className="sidebarcode"><i className="far fa-envelope"></i>Sidebar</label>
                    <label htmlFor="image" className="image"><i className="far fa-user"></i>Image</label>
                    <label htmlFor="login" className="login"><i className="far fa-user"></i>Login</label>
                    <div className="slider"></div>
                </div>
                <section>
                    <div className="SourceCodeContent SourceCodeContent-1">
                        <div className="title">Cards Source Code</div>
                        <Cards />
                    </div>
                    <div className="SourceCodeContent SourceCodeContent-2">
                        <div className="title">Header Source Code</div>
                        <Header />
                    </div>
                    <div className="SourceCodeContent SourceCodeContent-3">
                        <div className="title">Footer Source Code</div>
                        <Footers />
                    </div>
                    <div className="SourceCodeContent SourceCodeContent-4">
                        <div className="title">Sidebar Source Code</div>
                        <Sidebar />
                    </div>
                    <div className="SourceCodeContent SourceCodeContent-5">
                        <div className="title">Image Source Code</div>
                        <Images />
                    </div>
                    <div className="SourceCodeContent SourceCodeContent-6">
                        <div className="title">Login Source Code</div>
                        <Logins />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default SourceCode;
